import Checkbox from "../checkbox";

import { CardProps } from "./types";

export const CardWithCheckbox = ({
  title,
  description,
  onSelect,
  checked,
  id,
  onHover,
}: CardProps) => (
  <div
    className={`flex cursor-pointer select-none items-start gap-4 rounded-lg border p-4 transition-all duration-200 ease-in-out hover:border-blue-400 hover:shadow-md active:border-blue-500 ${
      checked ? "border-blue-500" : "border-gray-200"
    }`}
    onMouseEnter={() => onHover?.(id)}
    onClick={() => onSelect(id)}
  >
    <div className="mt-1 flex justify-center transition-all duration-200 ease-in-out">
      <Checkbox checked={checked} />
    </div>
    <div className="flex flex-col justify-center transition-colors duration-200 ease-in-out">
      <div className="text-base font-bold text-gray-900 transition-colors duration-200 ease-in-out">
        {title}
      </div>
      <div className="text-sm text-gray-600 transition-colors duration-200 ease-in-out">
        {description}
      </div>
    </div>
  </div>
);
